import React, { Suspense } from "react";
import ReactDataGrid from "react-data-grid";
import { withTranslation } from "react-i18next";
import { DropdownButton, Dropdown } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import { PaymentModal } from "../PaymentModalPage";
import {
  userService,
  dataService,
  creditCardService,
  genericCodesService,
  cardsService,
} from "../_services";
import { AppHeader } from "../AppHeader";

class PrePaidCounters_ extends React.Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    this._columns = [
      {
        key: "SEQ",
        name: t("seq"),
        width: 50,
        resizable: true,
      },
      {
        key: "SERIAL_NO",
        name: t("serial_no"),
        width: 130,
        resizable: true,
      },
      {
        key: "MeterBalance",
        name: t("MeterBalance"),
        formatter: (data) => {
          return <span className={data.value < 100 ? "colorRed bgColorRed" : "colorGreen bgColorGreen"}>{data.value}</span>;
        },
        width: 80,
        resizable: true,
      },
      {
        key: "HNAME",
        name: t("counter_code_hname"),
        width: 100,
        resizable: true,
      },
      {
        key: "CUSTOMER_NO",
        name: t("customer_no"),
        resizable: true,
      },
    ];
    let user = userService.getUser();
    let card = cardsService.getCardfromSessionStorage();

    this.state = {
      user: user,
      card: card,
      rows: [],
      selectedIndex: [],
      mounted: true,
      prepaidSum: 0,
      modalShow: false,
      loading: false,
      submitted: false,
      zCreditUrl: "",
      refresh: false,
      old_payemnt_percentage: 0,
      pinpad: "",
      payments_no: 1,
    };

    // if (card !== undefined && (this.state.card === undefined ||
    //     card.ID !== this.state.card.ID)) {
    //     this.setState({ card: card });
    // }

    this.getPrePaidCounters();
    genericCodesService
      .getGenCode("SYSTEM_PARAM", "O_PYM_PERC")
      .then((genCodeObj) => {
        console.log(genCodeObj);
        try {
          this.setState({
            old_payemnt_percentage: parseInt(genCodeObj.GEN_DESC),
          });
        } catch (e) {
          this.setState({ old_payemnt_percentage: 0 });
        }
      });

    this.handlPaymentsNoChange = this.handlPaymentsNoChange.bind(this);
  }

  componentDidMount() {
    genericCodesService.getPinpad().then(pinpadObj => {
      this.setState({ pinpad: pinpadObj.pinpad || '' })
    })
  }
  handlPaymentsNoChange(event) {
    this.setState({ payments_no: event.target.value });
  }

  handleCardChanged = (card) => {
    console.log(card);
    const currentCardID = this.state.card.ID || "-";
    if (card.ID !== currentCardID) {
      this.setState({
        card: card,
        rows: [],
        selectedIndex: [],
        prepaidSum: 0,
      });
      this.getPrePaidCounters();
    }
  };


  getPrePaidCounters = () => {
    const user = this.state.user;
    const card = this.state.card;
    if (user && user.token && card && card.ID) {
      dataService.getPrePaidCounters(card.ID, user.token).then((counters) => {
        console.log(counters);
        counters.forEach((element, index) => {
          counters[index].MeterBalance = (
            <img
              alt="loading"
              src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
            />
          );
        });
        this.setState({ rows: counters, selectedIndex: [], prepaidSum: 0 });
        this.getMeterBalance(counters);
      });
    }
  };

  getMeterBalance = (counters) => {
    counters.forEach((element, index) => {
      dataService
        .getMeterBalance(this.state.user.token, element.SERIAL_NO, element.SEQ)
        .then((result) => {
          console.log(result);
          if (result.error === true) return;
          counters[index].MeterBalance = result.MeterBalanceResult.MeterBalance;
          this.setState({ refresh: true });
          this.setState({ rows: counters });
        });
    });
  };

  rowGetter = (i) => {
    return this.state.rows[i];
  };

  onRowsSelected = (rows) => {
    let rowIndexes = rows.map((r) => r.rowIdx);
    this.setState({ selectedIndex: rowIndexes });
    console.log("%c Rows:", "background: #222; color: #bada55");
    console.log(rows);
  };

  onRowsDeselected = (rows) => {
    let rowIndexes = rows.map((r) => r.rowIdx);
    this.setState({
      selectedIndex: this.state.selectedIndex.filter(
        (i) => rowIndexes.indexOf(i) === -1
      ),
    });
  };

  handlecreateSession = (event) => {
    event.preventDefault();
    const payLoadObj = {
      ...this.state.user,
      ...this.state.rows[this.state.selectedIndex],
    };
    creditCardService
      .createSession({
        card_id: this.state.card.ID,
        token: this.state.user.token,
        item_list: this.state.rows[this.state.selectedIndex].SERIAL_NO,
        item_sum: this.state.prepaidSum,
        card_full_name: this.state.card.H_FULL_NAME,
        client_url_origin: window.location.origin,
        item_type: "prepaid",
        payLoadObj,
        paymentType: "regular",
      })
      .then((data) => {
        console.log(data);
        //window.open(data.url, "_blank");
        this.setState({ modalShow: true, zCreditUrl: data.url });
      })
      .catch((error) => {
        console.error("Error:", error);
        return { error: true, message: error.toString() };
      });
  };

  handlePinpadSelect = (e) => {
    const payLoadObj = {
      ...this.state.card,
      PaymentSum: this.state.prepaidSum,
      ...this.state.rows[this.state.selectedIndex],
    };
    creditCardService
      .pinpadCommitFullTransaction({
        card_id: this.state.card.ID,
        token: this.state.user.token,
        item_list: this.state.rows[this.state.selectedIndex].SERIAL_NO,
        item_sum: this.state.prepaidSum,
        payments_no: this.state.payments_no,
        card_full_name: this.state.card.H_FULL_NAME,
        client_url_origin: window.location.origin,
        item_type: "prepaid",
        payLoadObj,
        paymentType: "regular",
        pinpad: e,
      })
      .then((data) => {
        console.log(data);
        if (data.error || !data.success) {
          toast.error(data.message || this.props.t("transaction_not_applyed"));
        } else {
          const reciept_url = `${window.location.origin}/credit_card?UniqueID=${data.UniqueID}&PaymentType=regular`;
          //window.open(reciept_url, "_blank");
          this.setState({ modalShow: true, zCreditUrl: reciept_url });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error(this.props.t("transaction_not_applyed"));
        return { error: true, message: error.toString() };
      });
  };

  handleModalHide = () => {
    this.setState({ modalShow: false });
    this.getPrePaidCounters();
  };

  getSize() {
    let count = this.state.rows.length;
    if (this.state.refresh && count > 0) {
      count--; // hack for update data-grid
      this.setState({
        refresh: false,
      });
    }
    return count;
  }
  render() {
    console.log(this.state.rows);
    const { t } = this.props;
    const hasRows =
      this.state.rows === null || (this.state.rows?.length || 0) === 0
        ? false
        : true;

    //const selectedIndex = this.state.selectedIndex;
    //const rowText = selectedIndex.length === 1 ? t("row") : t("rows");
    //const error = this.state.rows?.error || null;
    //const message = this.state.rows?.message || null;
    return (
      <Suspense fallback="loading">
        <ToastContainer rtl />
        <div className="col-md-8 autoCenter">
          <AppHeader
            user={this.state.user}
            onCardChanged={this.handleCardChanged}
          />

          {!hasRows && (
            <div>
              <h4>{t("no_prepaid_counters")}</h4>
            </div>
          )}
          {hasRows && (
            <div>
              <div
                className={
                  "form-group" + (!this.state.prepaidSum ? " has-error" : "")
                }
              >
                <div className="elements-line">
                  {/* {this.state.old_payemnt_percentage > 0 && (
                  <h5 className="text-danger">
                    {this.state.old_payemnt_percentage +
                      t("old_pym_percentage")}
                  </h5>
                )} */}
                  <label className="formGrouplabel50" htmlFor="prepaidSum">
                    {t("prepaidSum")}
                  </label>
                  <input
                    className="formGroupInput15"
                    type="text"
                    name="prepaidSum"
                    value={this.state.prepaidSum}
                    onChange={(event) => {
                      this.setState({ prepaidSum: event.target.value });
                    }}
                  />
                  <Link
                    className={
                      this.state.prepaidSum > 0 &&
                        this.state.selectedIndex.length > 0
                        ? "pym-link"
                        : "pym-link-disabled"
                    }
                    to=""
                    onClick={(event) => this.handlecreateSession(event)}
                  >
                    {t("get_request_token")}
                  </Link>
                </div>
                {this.state.pinpad.length > 0 &&
                  this.state.user.LOGIN_ROLE === "U" &&
                  this.state.prepaidSum > 0 &&
                  this.state.selectedIndex.length > 0 && (
                    <div className="elements-line">
                      <DropdownButton
                        key={`dropdown-button-drop-down`}
                        id={`dropdown-button-drop-down`}
                        drop="down"
                        variant="primary"
                        title={` pinpad `}
                        onSelect={this.handlePinpadSelect}
                      >
                        {this.state.pinpad.split(",").map((pinpad_id) => (
                          <Dropdown.Item key={pinpad_id} eventKey={pinpad_id}>
                            {pinpad_id}
                          </Dropdown.Item>
                        ))}
                      </DropdownButton>
                      <label className="formGrouplabel50" htmlFor="payments_no">
                        {t("payments_no")}
                      </label>
                      <input
                        className="formGroupInput15 no-border"
                        type="text"
                        name="payments_no"
                        pattern="[0-9]*"
                        value={this.state.payments_no}
                        onChange={this.handlPaymentsNoChange}
                        onFocus={(event) => event.target.select()}
                      />
                    </div>
                  )}
                {this.state.old_payemnt_percentage > 0 && (
                  <h6 className="text-danger">
                    {this.state.old_payemnt_percentage +
                      t("old_pym_percentage")}
                  </h6>
                )}
                {this.loading && (
                  <img
                    alt="loading"
                    src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
                  />
                )}

                {this.submitted &&
                  this.state.prepaidSum <= 0 &&
                  this.state.selectedIndex.length > 0 && (
                    <div className="help-block">
                      {t("prepaidSum")} {t("incorrect")}
                    </div>
                  )}
              </div>
              <ReactDataGrid
                rowKey="id"
                columns={this._columns}
                rowGetter={this.rowGetter}
                rowsCount={this.getSize()}
                rowSelection={{
                  showCheckbox: true,
                  enableShiftSelect: false,
                  onRowsSelected: this.onRowsSelected,
                  onRowsDeselected: this.onRowsDeselected,
                  selectBy: {
                    indexes: this.state.selectedIndex,
                  },
                }}
              />

              {this.state.modalShow && (
                <PaymentModal
                  show={this.state.modalShow}
                  z_credit_url={this.state.zCreditUrl}
                  onHide={() => this.handleModalHide()}
                ></PaymentModal>
              )}
            </div>
          )}
        </div>
      </Suspense>
    );
  }
}

const PrePaidCounters = withTranslation()(PrePaidCounters_);
export { PrePaidCounters };
